import { useBuwlCKOContext } from '../context/GlobalBuwlCkoAppContext';
import { useEffect } from 'react';
import { BuwlSourceSystem } from '../model/IBuwlCKOContext';

const ENV: string = process.env.REACT_APP_ENV || 'dev';
const FACEBOOK_PIXEL_ID_UA = process.env.REACT_APP_FACEBOOK_PIXEL_ID_UA || '';
const FACEBOOK_PIXEL_ID_PL = process.env.REACT_APP_FACEBOOK_PIXEL_ID_PL || '';

const AdvertiseMonitorInjection: React.FC = () => {
    const { buwlContext } = useBuwlCKOContext();

    useEffect(() => {
        if (ENV != 'prod') return;

        const facebookPixelId: string =
            buwlContext.sourceSystem == BuwlSourceSystem.BUWL_WEB_UA ? FACEBOOK_PIXEL_ID_UA : FACEBOOK_PIXEL_ID_PL;

        const script = document.createElement('script');
        script.innerHTML = `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${facebookPixelId}');
            fbq('track', 'PageView');
        `;
        const noscript = document.createElement('noscript');
        const image = document.createElement('img');
        image.src = `https://www.facebook.com/tr?id=${facebookPixelId}&ev=PageView&noscript=1`;
        image.style.display = 'none';
        image.height = 1;
        image.width = 1;
        noscript.appendChild(image);

        const head = document.head;
        if (head.firstChild) {
            head.insertBefore(noscript, head.firstChild);
            head.insertBefore(script, noscript);
        } else {
            document.head.appendChild(script);
            document.head.appendChild(noscript);
        }

        return () => {
            document.head.removeChild(script);
            document.head.removeChild(noscript);
        };
    }, [buwlContext]);

    return null;
};

export default AdvertiseMonitorInjection;
